import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { AiFeaturesService } from '@maximizer/ai/data-access';
import { EmbeddedComponent } from '@maximizer/core/shared/ui/components/base';
import { ActionEventType } from '@maximizer/core/shared/ui/config';
import { IQBoostArgs } from '../classes/iqboost';
import { IqboostClassicComponent } from '../iqboost-classic/iqboost-classic.component';
import { IqboostAllHouseholdsComponent } from '../iqboost-v2/iqboost-all-households/iqboost-all-households.component';
import { IqboostSingleHouseholdComponent } from '../iqboost-v2/iqboost-single-household/iqboost-single-household.component';

type IQBoostDialog = 'classic' | 'singleHousehold' | 'allHouseholds';

@Component({
  selector: 'ai-iqboost',
  templateUrl: './iqboost.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IqboostAllHouseholdsComponent,
    IqboostClassicComponent,
    IqboostSingleHouseholdComponent,
  ],
})
export class IqboostComponent extends EmbeddedComponent {
  @HostBinding('class') hostClasses = 'ai-ng ai-headless-ng';

  private readonly aiFeatures = inject(AiFeaturesService);
  private readonly changeDetector = inject(ChangeDetectorRef);

  private readonly dialogView = viewChild<EmbeddedComponent>('dialogView');

  protected readonly dialog = signal<IQBoostDialog | null>(null);

  constructor() {
    super(inject(ElementRef));
  }

  override doAction(name: string, args?: IQBoostArgs): void {
    if (name === ActionEventType.Show || name === ActionEventType.Initialize) {
      this.dialog.set(this.dialogFor(args));
      // Renders the dialog right away: it is created by rendering, and this show is for it.
      this.changeDetector.detectChanges();
      this.dialogView()?.doAction(name, args);
    } else {
      super.doAction(name, args);
    }
  }

  private dialogFor(args?: IQBoostArgs): IQBoostDialog {
    if (!this.aiFeatures.isIQBoostV2Enabled()) {
      return 'classic';
    }
    return args?.key ? 'singleHousehold' : 'allHouseholds';
  }
}
